// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/ApplicationInformationService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { ApplicationInformationDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/ApplicationInformationService.proto.
 */
export const file_Services_ApplicationInformationService: GenFile = /*@__PURE__*/
  fileDesc("CixTZXJ2aWNlcy9BcHBsaWNhdGlvbkluZm9ybWF0aW9uU2VydmljZS5wcm90bzKLAgodQXBwbGljYXRpb25JbmZvcm1hdGlvblNlcnZpY2US6QEKGUdldEFwcGxpY2F0aW9uSW5mb3JtYXRpb24SFi5nb29nbGUucHJvdG9idWYuRW1wdHkaNy50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLkFwcGxpY2F0aW9uSW5mb3JtYXRpb25EdG8ie6DazQ8BgtPkkwJwWjciNS9hcGkvYXBwbGljYXRpb25JbmZvcm1hdGlvbi9nZXRBcHBsaWNhdGlvbkluZm9ybWF0aW9uEjUvYXBpL2FwcGxpY2F0aW9uSW5mb3JtYXRpb24vZ2V0QXBwbGljYXRpb25JbmZvcm1hdGlvbkIkqgIhTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLlNlcnZpY2VzYgZwcm90bzM", [file_google_api_annotations, file_google_protobuf_empty, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Options_MethodOptions]);

/**
 * Provides information about the TimeTracking application.
 *
 * @generated from service ApplicationInformationService
 */
export const ApplicationInformationService: GenService<{
  /**
   * Returns application and assembly versioning information.
   *
   * @generated from rpc ApplicationInformationService.GetApplicationInformation
   */
  getApplicationInformation: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ApplicationInformationDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_ApplicationInformationService, 0);

